<sv-ng-element-title [element]="element"></sv-ng-element-title>
<div *ngIf="element.hasDescriptionUnderTitle" [class]="element.cssDescription" [model]="element.locDescription" [attr.id]="element.ariaDescriptionId" [style.display]="element.hasDescription ? '': 'none' " sv-ng-string></div>
<ng-container *ngIf="element.hasAdditionalTitleToolbar">
<sv-ng-action-bar [model]="element.additionalTitleToolbar"></sv-ng-action-bar>
</ng-container>